<template>
    <div class="main-content">
        <div class="main-content-container" v-show="show_step_one && !password_reset_sent">
            <div class="form">
                <div class="error-general" v-if="general_errors && general_errors.length > 0">
                    {{ general_errors }}
                </div>
                <h2>Forgot password?</h2>

                <div class="form-text">
                    Enter your email address and we'll send you a secure link to reset your password.
                </div>
                <div class="form-text">
                    If you haven't forgotten your password, you can always go back to
                    <a href="javascript:{}" @click="$router.push({ path: '/login' })">login</a>
                    page and enter your email and password.
                </div>
                <custom-input
                    error_msg="* Email not valid"
                    input_type="email"
                    autofocus="true"
                    :invalid="errors && errors.includes('email')"
                    @enter="send_email()"
                    @change="set_value"
                    :value="user.email"
                    :required="true"
                    name="email"
                    label="Your email"
                ></custom-input>

                <div class="form-submit">
                    <a @click="send_email" href="javascript:{}" class="btn-primary">Send</a>
                </div>
            </div>
            <div class="form-text form-text--bottom">
                <p>
                    Not registered? You can sign up
                    <a @click="$router.push({ path: '/signup' })" href="javascript:{}">here</a>
                </p>
            </div>
        </div>

        <div class="main-content-container" v-if="password_reset_sent">
            <div class="form">
                <div class="error-general" v-if="general_errors && general_errors.length > 0">
                    {{ general_errors }}
                </div>
                <h2>We just sent an email to:</h2>
                <div class="form-text--bold">
                    {{ user.email }}
                </div>
                <div class="form-text">
                    Click the secure link we sent you to reset your password. If you not find an email, please check
                    your Spam folder.
                    <a href="javascript:{}" @click="$router.push({ path: '/login' })" class="btn btn-default btn-forgot"
                        >Ok</a
                    >
                    Still did not get email?
                    <a @click="send_email" href="javascript:{}">Resend</a>
                </div>
            </div>
            <div class="form-text form-text--bottom">
                <p>
                    Not registered? You can sign up
                    <a @click="$router.push({ path: '/signup' })" href="javascript:{}">here</a>
                </p>
            </div>
        </div>

        <div class="main-content-container" v-if="!show_step_one && !password_reset_sent">
            <div class="form">
                <div class="error-general" v-if="general_errors && general_errors.length > 0">
                    {{ general_errors }}
                </div>
                <h2>Change password</h2>
                <div class="form-text--bold">
                    {{ user.email }}
                </div>
                <custom-input
                    error_msg="* Password must be at least 12 characters"
                    @change="set_value"
                    input_type="password"
                    :invalid="errors && errors.includes('password')"
                    :value="user.password"
                    icon_class="icon-eye"
                    :required="true"
                    name="password"
                    label="Your password"
                ></custom-input>

                <div class="form-row">
                    <a @click="login_click" href="javascript:{}" class="btn-primary">Log in</a>
                </div>
            </div>
            <div class="form-text form-text--bottom">
                <p>
                    Not registered? You can sign up
                    <a @click="$router.push({ path: '/signup' })">here</a>
                </p>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from "vuex";
import customInput from "@/components/pages/custom-input.vue";
export default {
    name: "forgot-password-page-page",
    components: { customInput },
    computed: {
        ...mapState(["errors"]),
        ...mapState(["password_reset_sent"]),
        ...mapState(["general_errors"]),
        ...mapState(["user"])
    },
    data() {
        let email = window.get_argument("e");
        if (!email) {
            if (this.user && this.user.email) {
                console.log("here");
                email = this.user.email;
            }
        }
        if (email) {
            this.set_value({ prop_name: "email", prop_value: email });
        }
        return {
            inputIsVisible: false,
            link_expired: false,
            email: email,
            show_step_one: window.get_argument("act") !== "reset-password"
        };
    },
    mounted() {
        this.$store.commit("set_errors", []);
        this.$store.commit("set_global_errors", []);
        if (!this.show_step_one) {
            this.check_password_link_validity();
        }
    },
    methods: {
        ...mapActions(["change_password"]),
        ...mapMutations(["set_user"]),
        ...mapActions(["forgot_password"]),
        ...mapActions(["is_password_reset_hash_valid"]),
        set_value(args) {
            let user = { ...this.user };
            user[args.prop_name] = args.prop_value;
            this.set_user(user);
        },
        check_password_link_validity() {
            let response = this.is_password_reset_hash_valid(this.user).then(resp => {
                if (response && response.data && response.data.link_expired) {
                    this.link_expired = response.data.link_expired;
                    if (this.link_expired) {
                        this.$store.commit("set_global_errors", "Password reset link has expired");
                    }
                }
            });
        },
        send_email() {
            this.$store.commit("set_errors", []);
            this.$store.commit("set_global_errors", null);
            let fields_to_validate = ["email"];
            fields_to_validate.forEach(field => {
                if (!this.user[field]) {
                    this.errors.push(field);
                }
            });
            if (this.user.email && !window.validate_email(this.user.email)) {
                if (!this.errors.includes("email")) {
                    this.errors.push("email");
                }
            }
            if (this.errors && this.errors.length === 0) {
                this.forgot_password(this.user);
            }
        },
        login_click() {
            this.set_value({
                prop_value: this.email,
                prop_name: "email"
            });
            this.$store.commit("set_errors", []);
            this.$store.commit("set_global_errors", null);
            this.check_password_link_validity();
            if (!this.link_expired) {
                let fields_to_validate = ["password"];
                fields_to_validate.forEach(field => {
                    if (!this.user[field]) {
                        this.errors.push(field);
                    }
                });
                if (this.user.password && !window.validate_password(this.user.password)) {
                    if (!this.errors.includes("password")) {
                        this.errors.push("password");
                    }
                }
                if (this.errors && this.errors.length === 0) {
                    let payload = {
                        email: this.user.email,
                        pw: this.user.password,
                        h: window.get_argument("h")
                    };
                    this.change_password(payload);
                }
            } else {
                this.$store.commit("set_global_errors", "Password reset link has expired");
            }
        }
    }
};
</script>
<style scoped>
@media (max-width: 82rem) {
    .main-content {
        height: 60vh;
        overflow: auto;
    }
}
</style>
